<template>
  <div>
    <div v-if="showShell" class="console-shell">
      <aside class="sidebar">
        <div class="brand-block">
          <div class="brand-mark"></div>
          <div class="brand-text">
            <h1>印度蜜蜂</h1>
          </div>
        </div>

        <nav class="side-nav">
          <template v-for="group in groupedMenus">
            <div :key="group.name + '-label'" class="nav-section-label">{{ group.name }}</div>
            <router-link
              v-for="menu in group.items"
              :key="menu.path"
              :to="menu.path"
              :class="{ active: isMenuActive(menu) }"
            >
              <i class="ico" v-html="menuIcon(menu)"></i>
              <span>{{ menu.title }}</span>
            </router-link>
          </template>
        </nav>

        <div class="side-status">
          <div class="pulse-row">
            <span>网关运行正常</span>
            <i class="pulse"></i>
          </div>
          <div class="mini-line">
            <svg viewBox="0 0 180 32" preserveAspectRatio="none">
              <path d="M0 22 C22 18, 28 6, 46 10 S72 30, 92 18 S118 7, 138 11 S160 24, 180 15" fill="none" stroke="#32c8f5" stroke-width="2"/>
            </svg>
          </div>
        </div>
      </aside>

      <div class="main-area">
        <header class="topbar">
          <div class="topbar-title-wrap">
            <h2 class="topbar-title">{{ pageTitle }}</h2>
          </div>

          <div class="topbar-actions">
            <el-dropdown @command="handleCommand" trigger="click">
              <button class="topbar-user" type="button">
                <span class="topbar-avatar">{{ avatarText }}</span>
                <span class="topbar-user-meta">
                  <strong>{{ currentUserLabel }}</strong>
                  <small>已登录</small>
                </span>
              </button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="logout"><i class="el-icon-switch-button"></i> 退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </header>

        <section class="content">
          <router-view />
        </section>
      </div>
    </div>
    <router-view v-else />
  </div>
</template>

<script>
const GROUP_BY_PATH = [
  { name: '个人流量包', patterns: ['/admin/users', '/user/profile', '/user/quick-config'] }
]

function groupOf(path) {
  for (const g of GROUP_BY_PATH) {
    if (g.patterns.some(p => path === p || path.startsWith(p))) return g.name
  }
  return '其它'
}

export default {
  name: 'App',
  data() {
    return {
      iconMap: {
        '/admin/users': '<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><circle cx="12" cy="8" r="3.2"/><path d="M5 20c1.5-4 12.5-4 14 0"/></svg>',
        '/user/profile': '<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>',
        '/user/quick-config': '<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M12 8v4l2.5 2.5"/><line x1="7" y1="8" x2="9" y2="8"/><line x1="7" y1="12" x2="9" y2="12"/><line x1="7" y1="16" x2="9" y2="16"/></svg>'
      }
    }
  },
  computed: {
    role() {
      return localStorage.getItem('role') || ''
    },
    showShell() {
      return this.$route.path !== '/login'
    },
    pageTitle() {
      if (this.$route.path.startsWith('/admin/users/')) {
        return '用户详情 / 计费'
      }
      const menu = this.menus.find(item => item.path === this.$route.path)
      return menu ? menu.title : '印度蜜蜂'
    },
    menus() {
      if (this.role === 'admin') {
        return [
          { path: '/admin/users', title: '用户管理', activePatterns: ['/admin/users'], icon: '/admin/users' }
        ]
      }
      return [
        { path: '/user/profile', title: '我的面板', icon: '/user/profile' },
        { path: '/user/quick-config', title: '快速配置', icon: '/user/quick-config' }
      ]
    },
    groupedMenus() {
      const order = GROUP_BY_PATH.map(g => g.name).concat(['其它'])
      const map = new Map()
      this.menus.forEach(m => {
        const g = groupOf(m.path)
        if (!map.has(g)) map.set(g, [])
        map.get(g).push(m)
      })
      return order
        .filter(name => map.has(name))
        .map(name => ({ name, items: map.get(name) }))
    },
    currentUserLabel() {
      return this.role === 'admin' ? '管理员' : '个人用户'
    },
    avatarText() {
      return this.role === 'admin' ? '管' : '用'
    }
  },
  methods: {
    menuIcon(menu) {
      const svg = this.iconMap[menu.icon]
      if (svg) return svg
      return '<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M4 7.5 12 3l8 4.5-8 4.5z"/><path d="M4 7.5v9L12 21l8-4.5v-9"/><path d="M12 12v9"/></svg>'
    },
    isMenuActive(menu) {
      if (!menu.activePatterns || menu.activePatterns.length === 0) {
        return this.$route.path === menu.path
      }
      return menu.activePatterns.some(pattern => {
        if (pattern.endsWith('/')) {
          return this.$route.path.startsWith(pattern)
        }
        return this.$route.path === pattern || this.$route.path.startsWith(pattern + '/')
      })
    },
    handleCommand(command) {
      if (command === 'logout') {
        this.logout()
      }
    },
    logout() {
      localStorage.removeItem('token')
      localStorage.removeItem('role')
      this.$router.push('/login')
      this.$message.success('已退出登录')
    }
  }
}
</script>

<style scoped>
.console-shell {
  display: grid;
  grid-template-columns: 248px 1fr;
  height: 100vh;
  color: var(--text);
}

/* ---------- Sidebar ---------- */
.sidebar {
  display: grid;
  grid-template-rows: auto 1fr auto;
  height: 100vh;
  padding: 24px 16px 16px;
  border-right: 1px solid var(--line);
  background: rgba(13, 21, 34, 0.9);
  backdrop-filter: blur(20px);
  overflow: hidden;
}

.brand-block {
  display: flex;
  align-items: center;
  gap: 12px;
  height: 52px;
  margin-bottom: 22px;
  padding: 0 6px;
}

.brand-mark {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  flex: none;
  background:
    radial-gradient(circle at 28% 18%, rgba(255,255,255,.94) 0 3%, transparent 4%),
    radial-gradient(circle at 76% 74%, rgba(37,240,255,.42), transparent 42%),
    radial-gradient(circle at 18% 78%, rgba(118,126,255,.28), transparent 36%),
    linear-gradient(150deg, rgba(255,255,255,.18), transparent 34%),
    linear-gradient(145deg, #10203a 0%, #12678b 48%, #20d6f4 100%);
  border: 1px solid rgba(183, 239, 255, .46);
  box-shadow: 0 18px 40px rgba(35, 215, 255, 0.3), 0 0 30px rgba(126,236,255,.18), inset -10px -12px 18px rgba(3,8,18,.5), inset 8px 8px 16px rgba(255,255,255,.16);
  overflow: hidden;
  position: relative;
}

.brand-mark::before {
  content: "";
  position: absolute;
  width: 23px;
  height: 23px;
  clip-path: polygon(50% 0%, 88% 22%, 88% 78%, 50% 100%, 12% 78%, 12% 22%);
  background:
    linear-gradient(135deg, rgba(255,255,255,.98), rgba(205,252,255,.8) 30%, rgba(35,215,255,.35) 31%, rgba(94,118,255,.58) 100%);
  box-shadow: 0 10px 22px rgba(0,0,0,.38), 0 0 22px rgba(66,236,255,.58), inset 0 0 0 1px rgba(255,255,255,.76), inset -5px -6px 10px rgba(5,12,25,.28);
  z-index: 2;
}

.brand-mark::after {
  content: "";
  position: absolute;
  inset: 3px;
  background: no-repeat center/100% 100% url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 72 72' fill='none'%3E%3Cellipse cx='48' cy='25' rx='8.5' ry='12.5' fill='%23ffffff' opacity='.82' transform='rotate(-16 48 25)'/%3E%3Cellipse cx='58' cy='22' rx='6' ry='9' fill='%23cfeaff' opacity='.55' transform='rotate(-38 58 22)'/%3E%3Cpath d='M25.5 34.5c.6-4.5-1-7-3.5-8.5' stroke='%232e1d08' stroke-width='2' stroke-linecap='round'/%3E%3Cpath d='M30.5 34c1.8-3.4 1-6.4-1-8.4' stroke='%232e1d08' stroke-width='2' stroke-linecap='round'/%3E%3Ccircle cx='22' cy='26' r='1.6' fill='%23ffd447'/%3E%3Ccircle cx='29.5' cy='25.7' r='1.6' fill='%23ffd447'/%3E%3Ccircle cx='22' cy='42' r='8.5' fill='%232e1d08'/%3E%3Ccircle cx='19' cy='39.5' r='2.6' fill='%23ffffff'/%3E%3Cpath d='M16.8 44.2c1.3 1.5 3.2 1.8 4.8.7' stroke='%23ffffff' stroke-width='1.6' stroke-linecap='round'/%3E%3Cellipse cx='41' cy='43' rx='17' ry='10.5' fill='%23ffd447' stroke='%232e1d08' stroke-width='2.2'/%3E%3Cpath d='M31 36.5 32 49.5' stroke='%232e1d08' stroke-width='4' stroke-linecap='round'/%3E%3Cpath d='M40 35.8 41.5 50.2' stroke='%232e1d08' stroke-width='4' stroke-linecap='round'/%3E%3Cpath d='M49 36.8 49.5 49.2' stroke='%232e1d08' stroke-width='4' stroke-linecap='round'/%3E%3Cpath d='M58 41.4h6.4l-2.4-2.4.8 4.8-2.4-2.4z' fill='%232e1d08'/%3E%3Cpath d='M30 51c-1 3-2 4-3.5 4.6M40 51.6c0 3.6 0 5 0 5.6M50 51c1.4 2.6 2.4 3.8 4 4.2' stroke='%232e1d08' stroke-width='1.8' stroke-linecap='round'/%3E%3C/svg%3E");
  filter: drop-shadow(0 0 11px rgba(37,240,255,.56));
  opacity: .98;
  z-index: 1;
}

.brand-text h1 {
  margin: 0;
  font-size: 22px;
  line-height: 1;
  font-weight: 850;
  color: #fff;
}

.brand-text small {
  display: block;
  margin-top: 6px;
  color: var(--muted);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

/* ---------- Nav ---------- */
.side-nav {
  display: grid;
  align-content: start;
  gap: 6px;
  overflow-y: auto;
  padding-right: 4px;
  min-height: 0;
}

.nav-section-label {
  margin: 14px 10px 6px;
  color: #60738f;
  font-size: 11px;
  font-weight: 850;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}
.nav-section-label:first-child {
  margin-top: 0;
}

.side-nav a {
  display: grid;
  grid-template-columns: 26px 1fr;
  align-items: center;
  gap: 8px;
  width: 100%;
  height: 42px;
  padding: 0 12px;
  border-radius: 8px;
  color: #a8b7cd;
  font-size: 14px;
  font-weight: 760;
  text-align: left;
}

.ico {
  width: 22px;
  height: 22px;
  display: grid;
  place-items: center;
  border-radius: 6px;
  color: inherit;
}

.ico svg {
  width: 18px;
  height: 18px;
  stroke: currentColor;
  stroke-width: 2;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.side-nav a:hover {
  background: rgba(255, 255, 255, 0.055);
  color: var(--text);
}

.side-nav a.active,
.side-nav a.router-link-exact-active {
  color: #fff;
  background: linear-gradient(90deg, rgba(79, 134, 255, 0.22), rgba(50, 200, 245, 0.08));
  box-shadow: inset 3px 0 0 var(--cyan);
}

/* ---------- Side status ---------- */
.side-status {
  margin-top: 14px;
  padding: 14px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.045);
}

.pulse-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 12px;
  color: var(--muted);
  font-weight: 800;
}

.pulse {
  width: 8px;
  height: 8px;
  border-radius: 99px;
  background: var(--green);
  box-shadow: 0 0 12px rgba(52, 201, 143, 0.55);
}

.mini-line {
  height: 32px;
  background: linear-gradient(90deg, transparent, rgba(50, 200, 245, 0.1));
  position: relative;
  overflow: hidden;
}

.mini-line svg {
  width: 100%;
  height: 100%;
}

/* ---------- Main area ---------- */
.main-area {
  min-width: 0;
  height: 100vh;
  overflow: auto;
}

.topbar {
  position: sticky;
  top: 0;
  z-index: 10;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0 28px;
  border-bottom: 1px solid var(--line);
  background: rgba(15, 23, 36, 0.86);
  backdrop-filter: blur(20px);
}

.topbar-title-wrap {
  min-width: 0;
}

.topbar-title {
  margin: 0;
  font-size: 24px;
  font-weight: 860;
  color: var(--text);
  line-height: 1.1;
}

.topbar-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.topbar-user {
  height: 42px;
  padding: 0 12px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.055);
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: var(--text);
  cursor: pointer;
}

.topbar-user:hover {
  border-color: rgba(50, 200, 245, 0.42);
  background: rgba(50, 200, 245, 0.08);
}

.topbar-avatar {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--blue), var(--cyan));
  color: #fff;
  font-size: 12px;
  font-weight: 900;
}

.topbar-user-meta {
  display: grid;
  gap: 1px;
  text-align: left;
}

.topbar-user-meta strong {
  font-size: 13px;
  line-height: 1.1;
  color: var(--text);
}

.topbar-user-meta small {
  font-size: 11px;
  line-height: 1.1;
  color: var(--green);
}

.content {
  padding: 22px 28px 42px;
  flex: 1;
  min-height: 0;
}

@media (max-width: 1200px) {
  .console-shell {
    grid-template-columns: 84px 1fr;
  }
  .brand-block {
    justify-content: center;
    padding: 0;
  }
  .brand-text {
    display: none;
  }
  .side-nav a {
    grid-template-columns: 1fr;
    justify-items: center;
    padding: 0;
  }
  .side-nav a .ico {
    font-size: 20px;
  }
  .side-nav a span {
    display: none;
  }
  .nav-section-label {
    display: none;
  }
  .side-status {
    display: none;
  }
}

@media (max-width: 760px) {
  .console-shell {
    display: block;
    height: auto;
    min-height: 100vh;
  }
  .sidebar {
    position: sticky;
    top: 0;
    z-index: 20;
    display: block;
    height: auto;
    padding: 10px 10px 8px;
    border-right: 0;
    border-bottom: 1px solid var(--line);
    overflow: hidden;
  }
  .brand-block {
    height: 38px;
    margin-bottom: 8px;
    justify-content: flex-start;
  }
  .brand-mark {
    width: 32px;
    height: 32px;
  }
  .brand-text {
    display: block;
  }
  .brand-text h1 {
    font-size: 18px;
  }
  .brand-text small {
    display: none;
  }
  .side-nav {
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
    gap: 10px;
    padding: 0 2px 8px;
    scroll-snap-type: x proximity;
  }
  .side-nav a {
    flex: 0 0 auto;
    width: 58px;
    height: 52px;
    padding: 0;
    grid-template-columns: 1fr;
    align-items: center;
    justify-items: center;
    scroll-snap-align: start;
    border-radius: 10px;
  }
  .side-nav a .ico {
    font-size: 22px;
  }
  .side-nav a .ico svg {
    width: 24px;
    height: 24px;
  }
  .side-status {
    display: none;
  }
  .topbar {
    position: static;
    height: auto;
    min-height: 64px;
    padding: 12px 14px;
    gap: 12px;
    align-items: flex-start;
  }
  .topbar-title {
    font-size: 18px;
  }
  .topbar-actions {
    margin-left: auto;
  }
  .topbar-user {
    height: 38px;
    padding: 0 8px;
  }
  .topbar-user-meta strong {
    font-size: 12px;
  }
  .content {
    padding: 12px 12px 28px;
  }
}
</style>